/** 50 play seconds = 1 island hour (72×). */
export const PLAY_S_PER_ISLAND_H = 50;
export const TOD_MIN_START = 16 * 60 + 10;
export const TOD_MINUTES_PER_DAY = 24 * 60;
export const NIGHT_HOUR_START = 19;
export const NIGHT_HOUR_END = 5.5;
export const ISLAND_MIN_PER_PLAY_S = 60 / PLAY_S_PER_ISLAND_H;

export class DayClock {
  /** FEED: night never ends. Clock still advances. */
  lockNight = false;
  private origin: number;
  private playS = 0;

  constructor(todMinutes = TOD_MIN_START) {
    this.origin = wrapMinutes(todMinutes);
  }

  /** Snap island clock. Used by lean-to sleep (05:30) and QA. */
  skipTo(todMinutes: number): void {
    this.origin = wrapMinutes(todMinutes);
    this.playS = 0;
  }

  /** Integer island minutes in 0..1439. */
  get todMinutes(): number {
    return Math.floor(this.todMinutesExact);
  }

  get isNight(): boolean {
    if (this.lockNight) {
      return true;
    }
    const hour = this.todMinutesExact / 60;
    return hour >= NIGHT_HOUR_START || hour < NIGHT_HOUR_END;
  }

  /** Advance by elapsed play seconds. Loop calls `tick(Clock.DT * n)`. */
  tick(dtSeconds: number): void {
    if (!Number.isFinite(dtSeconds) || dtSeconds <= 0) {
      return;
    }
    this.playS += dtSeconds;
  }

  private get todMinutesExact(): number {
    return wrapMinutes(this.origin + this.playS * ISLAND_MIN_PER_PLAY_S);
  }
}

function wrapMinutes(n: number): number {
  if (!Number.isFinite(n)) {
    return TOD_MIN_START;
  }
  const wrapped = n % TOD_MINUTES_PER_DAY;
  return wrapped < 0 ? wrapped + TOD_MINUTES_PER_DAY : wrapped;
}
